// Reuses the exporter style.json schema; only airspace paint is overridden.
const paintKeys = [
  "strokeWidth",
  "strokeColor",
  "lineDash",
  "haloWidth",
  "haloColor",
  "innerStrokeWidth",
  "innerStrokeColor",
  "innerStrokeOpacity",
  "fillColor",
  "zIndex",
  "label",
] as const;
export interface AirspaceStyleFile {
  airspace: {
    default?: { style: Record<string, unknown> };
    airspaces: { type: string; style: Record<string, unknown> }[];
  };
}
export async function loadAirspaceStyle(url?: string): Promise<AirspaceStyleFile | undefined> {
  if (!url) return undefined;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  try {
    const response = await fetch(url, { cache: "no-store", signal: controller.signal });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    if (
      !Array.isArray(data?.airspace?.airspaces) ||
      data.airspace.airspaces.some(
        (entry: any) => typeof entry?.type !== "string" || !entry.style || typeof entry.style !== "object"
      )
    ) {
      throw new Error("Invalid airspace style.json");
    }
    return data;
  } catch (error) {
    console.warn("[Airspace style] Using exported paint:", error);
    return undefined;
  } finally {
    clearTimeout(timeout);
  }
}
export function applyAirspaceStyle(properties: Record<string, any>, config?: AirspaceStyleFile): void {
  if (properties._objType !== 0 || typeof properties.airspaceType !== "string" || !config) return;
  const style =
    config.airspace.airspaces.find((entry) => entry.type.toLowerCase() === properties.airspaceType.toLowerCase())
      ?.style ?? config.airspace.default?.style;
  if (!style) return;
  // Replace paint, rather than merge: an omitted lineDash means a solid line.
  for (const key of paintKeys) delete properties[key];
  Object.assign(properties, {
    strokeWidth: 0,
    haloWidth: 0,
    innerStrokeWidth: 0,
    innerStrokeOpacity: 1,
    fillColor: "rgba(0,0,0,0)",
  });
  for (const key of paintKeys) if (Object.prototype.hasOwnProperty.call(style, key)) properties[key] = style[key];
}
